import React, { useState } from 'react';
import { CourseList } from './CourseList';
import { CourseWorkspace } from './CourseWorkspace';
import { useCourses } from './useCourses';

export function CourseGeneration() {
  const { courses, loading: coursesLoading, error: coursesError, refresh: loadCourses } = useCourses();
  const [selectedCourseId, setSelectedCourseId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const bannerError = [coursesError, error].filter(Boolean).join(' ');

  return (
    <div className="h-screen flex flex-col bg-background overflow-hidden">
      {/* Header */}
      <div className="border-b border-border bg-gray-50">
        <div className="px-6 pt-4">
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-semibold text-purple-900 mb-4">Course Management</h1>
            <div className="flex items-center gap-3 mb-4">
              {coursesLoading && <div className="text-sm text-gray-500">Loading...</div>}
            </div>
          </div>
        </div>
      </div>

      {/* Error banner */}
      {bannerError && (
        <div className="mx-6 mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          <p>{bannerError}</p>
        </div>
      )}

      <div className="p-6 flex-1 overflow-y-auto">
        {/* Course list view (no course selected) */}
        {!selectedCourseId && (
          <CourseList
            courses={courses}
            coursesLoading={coursesLoading}
            onSelectCourse={setSelectedCourseId}
            onNewCourseCreated={(id) => setSelectedCourseId(id)}
            onError={setError}
            loadCourses={loadCourses}
          />
        )}

        {/* Course detail view (course selected) */}
        {selectedCourseId && (
          <CourseWorkspace
            courseId={selectedCourseId}
            backLabel="Back to courses"
            onBack={() => setSelectedCourseId(null)}
            onError={setError}
          />
        )}
      </div>
    </div>
  );
}
